import {Text} from 'native-base';
import React from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';
import {t} from 'react-native-tailwindcss';
import i18n from '../lib/i18n';

type Props = {};

export const NotFoundScreen: React.FC<Props> = () => (
  <SafeAreaView style={[t.flex1, t.bgWhite]} edges={['bottom']}>
    <Text style={[t.text2xl, t.textCenter, t.pY5]}>{i18n.t('notFound')}</Text>
  </SafeAreaView>
);
